const AccStatus = require('./AccStatus');
const CarAlert = require('./CarAlert');
const CarAlertSeverity = require('./CarAlertSeverity');
const CarInsideRemark = require('./CarInsideRemark');
const CarModelStatus = require('./CarModelStatus');
const CardStatus = require('./CardStatus');
const CarsharingChargeStatus = require('./CarsharingChargeStatus');
const CarsharingChargeType = require('./CarsharingChargeType');
const CarsharingCouponType = require('./CarsharingCouponType');
const CarsharingOptionType = require('./CarsharingOptionType');
const CarsharingPassStatus = require('./CarsharingPassStatus');
const CarsharingPOIType = require('./CarsharingPOIType');
const CarsharingPriceType = require('./CarsharingPriceType');
const CarsharingStatus = require('./CarsharingStatus');
const CartStatus = require('./CartStatus');
const ChargingMode = require('./ChargingMode');
const ChargingStatus = require('./ChargingStatus');
const ChatMessageType = require('./ChatMessageType');
const ChatStatus = require('./ChatStatus');
const CheckStatus = require('./CheckStatus');
const CheckType = require('./CheckType');
const ClaimStatus = require('./ClaimStatus');
const Cleanliness = require('./Cleanliness');
const CodCarLifecycle = require('./CodCarLifecycle');
const CodCarSourceType = require('./CodCarSourceType');
const CodCarTrim = require('./CodCarTrim');
const CodContractLifecycle = require('./CodContractLifecycle');
const CodContractStatus = require('./CodContractStatus');
const CodContractV2Status = require('./CodContractV2Status');
const CodCustomerStatus = require('./CodCustomerStatus');
const CodDeliveryStatus = require('./CodDeliveryStatus');
const CodDeliveryType = require('./CodDeliveryType');
const CodFleetType = require('./CodFleetType');
const CodInventoryStatus = require('./CodInventoryStatus');
const CodOptionType = require('./CodOptionType');
const CodOrderStatus = require('./CodOrderStatus');
const CodReasonForTermination = require('./CodReasonForTermination');
const CodRepairStatus = require('./CodRepairStatus');
const Color = require('./Color');
const DamageStatus = require('./DamageStatus');
const DepositStatus = require('./DepositStatus');
const DriverStatus = require('./DriverStatus');
const EcoDrivingEvent = require('./EcoDrivingEvent');
const EcoDrivingLevel = require('./EcoDrivingLevel');
const EmailStatus = require('./EmailStatus');
const EngineStatus = require('./EngineStatus');
const EventLevel = require('./EventLevel');
const EventStatus = require('./EventStatus');
const ExportStatus = require('./ExportStatus');
const FamilySituation = require('./FamilySituation');
const FleetAccountSubscriptionStatus = require('./FleetAccountSubscriptionStatus');
const FleetAccountSubscriptionType = require('./FleetAccountSubscriptionType');
const FleetContractStatus = require('./FleetContractStatus');
const FleetDataProviderDeviceType = require('./FleetDataProviderDeviceType');
const FleetEcodrivingEventType = require('./FleetEcodrivingEventType');
const FleetEcodrivingSignalType = require('./FleetEcodrivingSignalType');
const FleetIncomingDataStatus = require('./FleetIncomingDataStatus');
const FleetKuanticContractServiceLevel = require('./FleetKuanticContractServiceLevel');
const FleetKuanticContractStatus = require('./FleetKuanticContractStatus');
const FleetMetricKey = require('./FleetMetricKey');
const FleetPack = require('./FleetPack');
const FleetPrivacyStatus = require('./FleetPrivacyStatus');
const FleetProcessNames = require('./FleetProcessNames');
const FleetPsaContractStatus = require('./FleetPsaContractStatus');
const FleetRemoteActionStatus = require('./FleetRemoteActionStatus');
const FleetService = require('./FleetService');
const FleetStatus = require('./FleetStatus');
const FleetTransmissionGearState = require('./FleetTransmissionGearState');
const FleetTripEventType = require('./FleetTripEventType');
const FollowUpStatus = require('./FollowUpStatus');
const Fuel = require('./Fuel');
const GpsSource = require('./GpsSource');
const HousingSituation = require('./HousingSituation');
const InsideCondition = require('./InsideCondition');
const InsuranceOptionType = require('./InsuranceOptionType');
const InvoiceStatus = require('./InvoiceStatus');
const InvoiceType = require('./InvoiceType');
const JobApplicationStatus = require('./JobApplicationStatus');
const JobOfferCommitment = require('./JobOfferCommitment');
const JobOfferExperienceLevel = require('./JobOfferExperienceLevel');
const JobOfferTeam = require('./JobOfferTeam');
const Language = require('./Language');
const LeadStatus = require('./LeadStatus');
const LoyaltyEventType = require('./LoyaltyEventType');
const MobilityPassStatus = require('./MobilityPassStatus');
const MoveType = require('./MoveType');
const OrchestraOrderStatus = require('./OrchestraOrderStatus');
const OutsideCondition = require('./OutsideCondition');
const ParkOptionType = require('./ParkOptionType');
const ParkPassStatus = require('./ParkPassStatus');
const ParkSponsorshipStatus = require('./ParkSponsorshipStatus');
const ParkStatus = require('./ParkStatus');
const PhoneCallStatus = require('./PhoneCallStatus');
const PhoneCallType = require('./PhoneCallType');
const PlaceType = require('./PlaceType');
const PrizeDrawStatus = require('./PrizeDrawStatus');
const PublicTransportType = require('./PublicTransportType');
const PushStatus = require('./PushStatus');
const Range = require('./Range');
const RatingStatus = require('./RatingStatus');
const RefillStatus = require('./RefillStatus');
const RentAdditionalField = require('./RentAdditionalField');
const RentOptionType = require('./RentOptionType');
const RentPassStatus = require('./RentPassStatus');
const RentStatus = require('./RentStatus');
const RideOptionType = require('./RideOptionType');
const RideStatus = require('./RideStatus');
const RideTrackingStatus = require('./RideTrackingStatus');
const RobStatus = require('./RobStatus');
const SeverityLevel = require('./SeverityLevel');
const ShuttleScheduleType = require('./ShuttleScheduleType');
const SiteType = require('./SiteType');
const SmartBadgeStatus = require('./SmartBadgeStatus');
const SmartCarConnector = require('./SmartCarConnector');
const SmartCarModelStatus = require('./SmartCarModelStatus');
const SmartCarTypeElectric = require('./SmartCarTypeElectric');
const SmartChargeStatus = require('./SmartChargeStatus');
const SmartContractStatus = require('./SmartContractStatus');
const SmartPgsfCdrStatus = require('./SmartPgsfCdrStatus');
const SmartTripStatus = require('./SmartTripStatus');
const StopSellType = require('./StopSellType');
const SupportCaseMessageType = require('./SupportCaseMessageType');
const SupportCaseStatus = require('./SupportCaseStatus');
const SupportingDocumentStatus = require('./SupportingDocumentStatus');
const SupportingDocumentType = require('./SupportingDocumentType');
const TextStatus = require('./TextStatus');
const TextType = require('./TextType');
const TicketStatus = require('./TicketStatus');
const TotalDaysMethod = require('./TotalDaysMethod');
const Transmission = require('./Transmission');
const TravelStatus = require('./TravelStatus');
const TripPlannerStrategy = require('./TripPlannerStrategy');
const Turn = require('./Turn');
const UserStatus = require('./UserStatus');
const VehicleStatus = require('./VehicleStatus');
const WebSocketClientStatus = require('./WebSocketClientStatus');
const WeekDay = require('./WeekDay');
const WidgetStatus = require('./WidgetStatus');
const WorkspaceUserStatus = require('./WorkspaceUserStatus');

module.exports = Object.freeze({
  AccStatus,
  CarAlert,
  CarAlertSeverity,
  CarInsideRemark,
  CarModelStatus,
  CardStatus,
  CarsharingChargeStatus,
  CarsharingChargeType,
  CarsharingCouponType,
  CarsharingOptionType,
  CarsharingPassStatus,
  CarsharingPOIType,
  CarsharingPriceType,
  CarsharingStatus,
  CartStatus,
  ChargingMode,
  ChargingStatus,
  ChatMessageType,
  ChatStatus,
  CheckStatus,
  CheckType,
  ClaimStatus,
  Cleanliness,
  CodCarLifecycle,
  CodCarSourceType,
  CodCarTrim,
  CodContractLifecycle,
  CodContractStatus,
  CodContractV2Status,
  CodCustomerStatus,
  CodDeliveryStatus,
  CodDeliveryType,
  CodFleetType,
  CodInventoryStatus,
  CodOptionType,
  CodOrderStatus,
  CodReasonForTermination,
  CodRepairStatus,
  Color,
  DamageStatus,
  DepositStatus,
  DriverStatus,
  EcoDrivingEvent,
  EcoDrivingLevel,
  EmailStatus,
  EngineStatus,
  EventLevel,
  EventStatus,
  ExportStatus,
  FamilySituation,
  FleetAccountSubscriptionStatus,
  FleetAccountSubscriptionType,
  FleetContractStatus,
  FleetDataProviderDeviceType,
  FleetEcodrivingEventType,
  FleetEcodrivingSignalType,
  FleetIncomingDataStatus,
  FleetKuanticContractServiceLevel,
  FleetKuanticContractStatus,
  FleetMetricKey,
  FleetPack,
  FleetPrivacyStatus,
  FleetProcessNames,
  FleetPsaContractStatus,
  FleetRemoteActionStatus,
  FleetService,
  FleetStatus,
  FleetTransmissionGearState,
  FleetTripEventType,
  FollowUpStatus,
  Fuel,
  GpsSource,
  HousingSituation,
  InsideCondition,
  InsuranceOptionType,
  InvoiceStatus,
  InvoiceType,
  JobApplicationStatus,
  JobOfferCommitment,
  JobOfferExperienceLevel,
  JobOfferTeam,
  Language,
  LeadStatus,
  LoyaltyEventType,
  MobilityPassStatus,
  MoveType,
  OrchestraOrderStatus,
  OutsideCondition,
  ParkOptionType,
  ParkPassStatus,
  ParkSponsorshipStatus,
  ParkStatus,
  PhoneCallStatus,
  PhoneCallType,
  PlaceType,
  PrizeDrawStatus,
  PublicTransportType,
  PushStatus,
  Range,
  RatingStatus,
  RefillStatus,
  RentAdditionalField,
  RentOptionType,
  RentPassStatus,
  RentStatus,
  RideOptionType,
  RideStatus,
  RideTrackingStatus,
  RobStatus,
  SeverityLevel,
  ShuttleScheduleType,
  SiteType,
  SmartBadgeStatus,
  SmartCarConnector,
  SmartCarModelStatus,
  SmartCarTypeElectric,
  SmartChargeStatus,
  SmartContractStatus,
  SmartPgsfCdrStatus,
  SmartTripStatus,
  StopSellType,
  SupportCaseMessageType,
  SupportCaseStatus,
  SupportingDocumentStatus,
  SupportingDocumentType,
  TextStatus,
  TextType,
  TicketStatus,
  TotalDaysMethod,
  Transmission,
  TravelStatus,
  TripPlannerStrategy,
  Turn,
  UserStatus,
  VehicleStatus,
  WebSocketClientStatus,
  WeekDay,
  WidgetStatus,
  WorkspaceUserStatus,
});
